$(function () {

  // タブ操作（ペア）
  tabmove("js-tab");
  tabmove("js-tab-pair");
  tabinit("js-tab");
  tabinit("js-tab-pair");

  function tabinit(cls) {
    $(window).on("load", function () {
      var type = getParam("page"),
      tabClass = "." + cls;
      console.log(type);
      if (type == "owner") {
        $(tabClass + " li").each(function () {
          var contents = $(".js-tabcontents"),
            parent = $(this).parent("ul"),
            pair = $(this).parents("div").hasClass("js-tab") == true ? $(".js-tab-pair") : $(".js-tab"),
            listItem = parent.find("li"),
            pairItem = pair.find("li");

          $("> *", contents).hide();
          contents.each(function () {
            $(this).find(".owner").show();
          });

          listItem.removeClass("active");
          pairItem.removeClass("active");

          $(this).addClass("active");
          $("li", pair).eq(2).addClass("active");
        });
      } else {
        return false;
      }
    });
  }

  function tabmove(cls) {
    var tabClass = "." + cls;
    $(tabClass+" li").each(function () {
      $(this).click(function () {
        var target = $(this).data("target"),
          contents = $(".js-tabcontents"),
          parent = $(this).parent("ul"),
          pair = $(this).parents("div").hasClass("js-tab") == true ? $(".js-tab-pair") : $(".js-tab"),
          listItem = parent.find("li"),
          pairItem = pair.find("li"),
          idx = $("li", parent).index($(this));

        $("> *", contents).hide();
        contents.each(function () {
          $(this).find("." + target).show();
        });

        listItem.removeClass("active");
        pairItem.removeClass("active");

        $(this).addClass("active");
        $("li", pair).eq(idx).addClass("active");
      });
    });
  }

  function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

});